import { co2 } from './common';

export default {
  'consumption.co2': `${co2}-päästöt yhdistetyt`,
  'consumption.energy': 'Virrankulutus yhdistetyssä testisyklissä',
  'consumption.fuel': 'Polttoaineen kulutus yhdistetty',
  'footnotes.local': '',
  'footnotes.wltp':
    'Ilmoitetut arvot ovat komission täytäntöönpanoasetuksen (EU) 2017/1153 artiklan 2 kohdan 3 mukaisia WLTP-pohjaisia hiilidioksidiarvoja. Polttoaineen kulutusarvot on laskettu näiden arvojen pohjalta. Virrankulutus on määritetty asetuksen (EY) N:o 683/2008 mukaisesti. Tiedot eivät koske yksittäistä autoa eivätkä ole osa tarjousta; tiedot on tarkoitettu vain auttamaan eri automallien vertailussa. Arvot vaihtelevat valittujen lisävarusteiden mukaan.',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Hakusanasi / Konfiguraattorin Online-koodi',
  'search.result.buy-online': 'Osta verkossa',
  'search.results': 'Ei tuloksia | {count} hakutulos | {count} hakutulosta',
  'search.results.count': '{count} hakutulosta',
  'search.results.backup': 'Ei tarkkoja osumia. Katso aiheeseen liittyvät sivut:',
  'search.results.none.summary': 'Tälle termille ei löydy hakutuloksia. Yritä uudelleen syöttämällä eri termi.',
  'search.show-more': 'Näytä lisää',
  'search.unavailable': 'Haku ei ole tällä hetkellä käytettävissä.',
  'search.result.new': 'Uusi',

  'input.placeholder': 'Hakusanasi / Konfiguraattorin Online-koodi',

  'suggestions.all_search_results': 'Kaikki hakutulokset',
  'suggestions.all_search_results_for': 'Näytä kaikki tulokset seuraavalle',
  'suggestions.in': 'kohdassa',

  all: 'Kaikki',
  UCOS: 'Used vehicle Online Store',
  PASSENGER_CARS: 'Henkilöautot',
  VANS: 'Pakettiautot',
  NCOS: 'New vehicle Online Store',
  VIDEO: 'Videot',
  DEALER_LOCATOR: 'Jälleenmyyjähaku',
  CONFIGURATOR: 'Suunnittele auto',
  TEST_DRIVE: 'Koeajo',
  VEHICLE_SEARCH: 'Used Cars',
  COLLECT: 'Collection & Lisävarusteet',
  CONNECT: 'Mercedes me Store',

  'search.result.consumption': 'Kulutus',
  'watch.video': 'Katso video',
  'input.recently': 'Viimeksi haettu',
  'input.help.title': 'Mitä sinun pitäisi etsiä?',
  'input.help.text': 'Etsi autotyyppejä, malleja, konfiguraatiokoodeja tai lisävarusteita, muita tuotteita ja tietoja.',

  'search.result.grid': 'Ruudukko',
  'search.result.list': 'Luettelo',

  // Empty result
  'support.check': 'Tarkista kirjoitusvirheiden varalta tai yritä uudelleen toisella hakusanalla.',
  'support.no.results': 'Tälle hakusanalle ei ole hakutuloksia.',
  'support.no.results.term': 'Tuloksia ei löytynyt.',
  'support.chat': 'Etkö löydä etsimääsi? Käytä meidän. ',
  'support.chat.with.us': 'Online-chat-tuki.',
};
